export default __webpack_public_path__ + "static/media/backgroundImage.5a0a390f.svg";